import { Component } from '@angular/core';

@Component({
  selector: 'app-ar-list',
  templateUrl: './ar-list.component.html',
  styleUrls: ['./ar-list.component.scss']
})
export class ArListComponent {

}
